/*
	OneGWP 2.0.0 Usage (Webpack)
	Yang @onerockwell
	
	Simple rule based GWP
	Rule: has none gift item in cart, get the free gift (defined in theme settings)
*/

// Import all dependencies here
import Backbone from 'backbone';
import { getRequest, postRequests } from '@/service/requests';

// Define the Backbone View here (Optional)
const OneGWPView = Backbone.View.extend({
  initialize: async function (settings) {
    const self = this;
    // Define a new console, to enable debugging logs please set 1r_debugging cookie with value of true using `ORW.utilities.setCookie('1r_debugging',true)`
    self.console = (function (oldCons) {
      return {
        log: function (text) {
          ORW.debugging && oldCons.log(text);
        },
        info: function (text) {
          ORW.debugging && oldCons.info(text);
        },
        warn: function (text) {
          ORW.debugging && oldCons.warn(text);
        },
        error: function (text) {
          oldCons.error(text);
          if (window?.newrelic) {
            var err = new Error(text);
            window.newrelic.noticeError(err);
          }
        }
      };
    })(window.console);

    self.console.log(`init GWP ...`);

    if (ORW.GWP.enable != `true`) {
      self.console.log(`GWP: GWP is disabled`);
      return false;
    }

    if (!ORW.GWP.free_product || ORW.GWP.free_product == ``) {
      self.console.log(`GWP: No free gift configured`);
      return false;
    }

    const response = await self.getProductByhandle(ORW.GWP.free_product);
    if (!response) {
      self.console.log(`GWP: No free gift found in system`);
      return false;
    }

    self.productData = response;
    const myCartWatcher = new CartWatcher();

    myCartWatcher.init();

    window.addEventListener('cart_changed', async (e) => {
      self.console.log(`GWP: Cart updated`);
      self.console.log(e.detail);
      const cartDetails = e.detail;
      if (cartDetails.currentCart) await self.validate(cartDetails.currentCart);
    });
  },

  events: {},

  onCartUpdate: async function (e) {},

  validate: async function (items) {
    const self = this;
    self.console.log(`GWP: Cart validating ... `);
    if (items.length) {
      self.console.log(items);
      const foundGift = items.filter(
        (item) => item.handle == ORW.GWP.free_product
      );
      if (!foundGift.length) {
        // Add the free gift
        self.console.log(`GWP: add the free gift ...`);
        await self.addFreeGift();
      } else if (foundGift.length == items.length) {
        // Remove the free gift
        self.console.log(`GWP: remove the free gift ...`);
        await self.removeFreeGift();
      } else {
        self.console.log(`GWP: no action`);
      }
    } else {
      self.console.log(`GWP: no action`);
    }
  },

  getProductByhandle: async function (handle) {
    const self = this;
    try {
      response = await getRequest(
        `${window.Shopify.routes.root}products/${handle}.js`
      );
      const responseData = await response.data;
      return responseData;
    } catch (error) {
      self.console.log(error);
      return false;
    }
  },

  addFreeGift: async function () {
    const self = this;
    const url = window.Shopify.routes.root + 'cart/add.js';

    const formData = {
      id: `${self.productData.variants[0].id}`,
      quantity: 1
    };
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    try {
      const response = await postRequests(url, formData, config);
      self.GWPChanged(response, `gwp_gift_added`);
      if (document.body.classList.contains(`template-cart`)) {
        location.reload();
      }
    } catch (error) {
      self.console.log(`Adding free gift error`);
      self.console.log(error);
    }
  },

  removeFreeGift: async function () {
    const self = this;
    const url = window.Shopify.routes.root + 'cart/change.js';

    const formData = {
      id: `${self.productData.variants[0].id}`,
      quantity: 0
    };
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    try {
      const response = await postRequests(url, formData, config);
      self.GWPChanged(response, `gwp_gift_removed`);
      if (document.body.classList.contains(`template-cart`)) {
        location.reload();
      }
    } catch (error) {
      self.console.log(`Remove free gift error`);
      self.console.log(error);
    }
  },

  GWPChanged: function (data = {}, eventNameOverride = '') {
    const self = this;
    const eventName = eventNameOverride ? eventNameOverride : `gwp_changed`;
    const event = new CustomEvent(eventName, { detail: data });
    window.dispatchEvent(event);
  },

  destroy: function () {
    const self = this;
    self.undelegateEvents();
  }
});

// Define the module here
const OneGWP = {
  init: function (settings) {
    // If using Backbone View
    return new OneGWPView(settings);

    // If not using Backbone View
    // return this;
  }
};

// Output the module
export default OneGWP;

class CartWatcher {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    response = await getRequest('/cart.js');
    return response.data;
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

  storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) =>
      l.filter((li) => !r.some((ri) => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
      currentCart: newCart.items
    };

    oldCart.items.forEach((oi) => {
      const ni = newCart.items.find(
        (i) => i.key == oi.key && i.quantity != oi.quantity
      );
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0 ? result.added.push(item) : result.removed.push(item);
    });

    return result;
  }

  async stall(milliseconds) {
    return new Promise((resolve) => {
      setTimeout(resolve, milliseconds);
    });
  }

  async emitCartChanges() {
    await this.stall(200); // Wait a few before getting the cart as the request could be WIP.
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    const event = new CustomEvent('cart_changed', { detail: changes });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach(async (entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(
          entry.initiatorType
        );
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          await this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ['resource'] });
  }
}
